import { PROFILE_POINTS } from '../constants';
import SectionHeading from './section-heading';

function ProfileSection() {
  return (
    <section id="profile" className="mx-auto grid max-w-6xl gap-10 px-5 py-20 md:grid-cols-[0.8fr_1.2fr]">
      <SectionHeading eyebrow="Source" title="Matched to FEVERDREAM.txt.">
        The visible profile now follows the provided FEVERDREAM source text directly.
      </SectionHeading>
      <div className="border border-fd-line bg-fd-paper p-4 shadow-document">
        <div className="grid gap-4 border-2 border-fd-ink p-5">
          {PROFILE_POINTS.map((point, index) => (
            <p key={point} className="border-b border-fd-line pb-4 text-lg leading-8 text-fd-stone last:border-b-0 last:pb-0">
              <span className="mr-4 font-black text-fd-ink">{String(index + 1).padStart(2, '0')}</span>
              {point}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProfileSection;
